import { memo } from "react";
import isEmpty from "lodash/isEmpty";
import { useLocation, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import SpecialOffer from "app/pages/.shared/SpecialOffer/SpecialOffer";
import { isServerSide, isUserMatchWithType } from "app/utils/utils";
import { useFlagship, useFsFlag } from "@flagship.io/react-sdk";

const BookingBannerPlaceholder = ({
	specialOffer = {},
	fallBackSpecialOffer = {},
	isSpecialOfferActive,
	userIsConnected,
}) => {
	const location = useLocation();
	const { productUri } = useParams();
	const isProductPage = Boolean(productUri);

	const usersFilterType = specialOffer?.ui?.usersFilter;
	const checkUserType = isUserMatchWithType(usersFilterType, userIsConnected);

	const fsShowFallbackSpecialOffer = useFsFlag("fallback_special_offer_show", true);
	const { status: fsStatus } = useFlagship();

	const shouldDisplaySpecialOfferOnCurrentPage =
		checkUserType &&
		(specialOffer.pages &&
			specialOffer.pages.find(page => {
				return location.pathname.includes(page) || (page === "product" && isProductPage);
			}));

	const shouldDisplaySpecialOfferFallbackOnCurrentPage =
		checkUserType &&
		(fsStatus.isSdkReady || (!isServerSide && window.Cypress)) &&
		fsShowFallbackSpecialOffer.getValue() &&
		fallBackSpecialOffer.pages &&
		fallBackSpecialOffer.pages.find(page => {
			return location.pathname.includes(page) || (page === "product" && isProductPage);
		});

	let specialOfferToDisplay = undefined;
	if (isSpecialOfferActive && shouldDisplaySpecialOfferOnCurrentPage) {
		specialOfferToDisplay = specialOffer;
	} else if (!isEmpty(fallBackSpecialOffer) && shouldDisplaySpecialOfferFallbackOnCurrentPage) {
		specialOfferToDisplay = fallBackSpecialOffer;
	}

	const shouldDisableFlexSpecialOffer = specialOfferToDisplay?.code === "FLEX";
	if (shouldDisableFlexSpecialOffer) {
		return null;
	}

	if (specialOfferToDisplay) {
		return (
			<div
				className="booking-marketing-placeholder"
				data-testid="booking-marketing-placeholder"
			>
				<SpecialOffer
					type={specialOfferToDisplay.type}
					title={specialOfferToDisplay.title}
					message={specialOfferToDisplay.summary}
					background={specialOfferToDisplay?.ui?.background}
					titleColor={specialOfferToDisplay?.ui?.titleColor}
					textColor={specialOfferToDisplay?.ui?.textColor}
					pictoUrl={specialOfferToDisplay?.ui?.pictoUrl}
					tooltipMessage={specialOfferToDisplay.details}
				/>
			</div>
		);
	}

	return null;
};

BookingBannerPlaceholder.propTypes = {
	specialOffer: PropTypes.object,
	fallBackSpecialOffer: PropTypes.object,
	isSpecialOfferActive: PropTypes.bool,
	userIsConnected: PropTypes.bool,
};

export default memo(BookingBannerPlaceholder);
